import Cookies from "js-cookie";

export function trackingConsent(value?: string): boolean {
  const consentCookies = Cookies.get("cookieconsent_dismissed");
  return (
    consentCookies &&
    (consentCookies.includes("gat") ||
      consentCookies.includes("all") ||
      consentCookies.includes("marketing") ||
      (value && consentCookies.includes(value)))
  );
}

export function trackErrorEvent(id: string, value: string) {
  if (trackingConsent()) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "fieldError",
        eventData: {
          [id]: value,
        },
      });
    } catch (e) {
      console.error(e);
    }
  }
}
